export default __webpack_public_path__ + "static/media/vs.2ed4b3b8.svg";